<template>
  <!--  专题首页-->
  <div class="poor">
    <div class="poor_box">
      <el-card >
        <el-form :inline="true" label-width="120px" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="留言内容">
                <el-input
                  placeholder="请输入标题"
                  v-model="searchData.message"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="留言人昵称">
                <el-input
                  placeholder="请输入昵称"
                  v-model="searchData.nickName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="审核状态">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.examineStatus"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in newsStatus"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="留言类型">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.type"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in messageType"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item>
            <el-button
              style="margin-left: 120px"
              type="primary"
              @click="messageSearch"
              >查询</el-button
            >
            <el-button
              style="margin-left: 20px"
              type="primary"
              @click="topicClear"
              >清空</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>

      <el-card 
      v-loading="loading"
      >
        <el-table
          :data="MessageList"
          :header-cell-style="getRowClass"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
            prop="title"
            label="标题"
            align="center"
            width="300"
            fixed
          ></el-table-column>
          <el-table-column
            prop="message"
            label="留言内容"
            align="center"
            width="300"
          ></el-table-column>
          <!-- <el-table-column
            prop="contentId"
            label="contentId"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="userInfoId"
            label="留言人的id"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="nickName"
            label="留言人昵称"
            align="center"
            width="200"
          ></el-table-column>

          <el-table-column
            prop="type"
            label="留言类型"
            align="center"
            width="120px"
          >
            <template slot-scope="{ row }">
              <span v-if="row.type == 1">新闻</span>
              <span v-if="row.type == 2">朋友圈</span>
              <span v-if="row.type == 3">大V</span>
              <span v-if="row.type == 4">音频</span>
              <span v-if="row.type == 5">视频</span>
              <span v-if="row.type == 6">专题</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="examineStatus"
            label="审核状态"
            align="center"
            width="200px"
          >
            <template slot-scope="{ row }">
              <div>
                <el-button size="mini" type="danger" v-if="row.examineStatus == 2">未提交审核</el-button>
                <el-button size="mini" type="warning" v-if="row.examineStatus == 3">审核中</el-button>
                <el-button size="mini" type="danger" v-if="row.examineStatus == 4">审核未通过</el-button>
                <el-button size="mini" type="success" v-if="row.examineStatus == 1">审核通过</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="留言时间"
            align="center"
            width="200px"
          ></el-table-column>

          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="180px"
            fixed="right"
          >
            <template slot-scope="{ row }">
              <div class="done">
                <el-button size="mini" style="width:90px;margin:0 0 10px 10px" type="success" @click="pass(row, 'yes')"
                  >通过</el-button
                >
                <el-button size="mini" type="danger" @click="pass(row, 'no')"
                  >不通过</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width: auto; marginright: 50px; margintop: 20px">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5, 10, 15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      MessageList: [], //留言列表
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示

      //查询的数据：
      searchData: {
        examineStatus: "", //审核状态
        type: "", //留言类型
        message: "", //留言内容
        nickName: "", //留言人昵称
      },

      //状态--下拉框：
      newsStatus: [
        // {
        //   value: "2",
        //   label: "未提交审核",
        // },
        {
          value: "3",
          label: "审核中",
        },
        {
          value: "4",
          label: "审核未通过",
        },
        {
          value: "1",
          label: "审核通过",
        },
      ],
      //留言类型--下拉框：
      messageType: [
        {
          value: 1,
          label: "新闻",
        },
        // {
        //   value: 2,
        //   label: "朋友圈",
        // },
        // {
        //   value: 3,
        //   label: "大V",
        // },
        {
          value: 4,
          label: "音频",
        },
        {
          value: 5,
          label: "视频",
        },
        {
          value: 6,
          label: "专题",
        },
      ],
      loading:false
    };
  },
  methods: {
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //留言列表：
    getList() {
      this.postAxios("/comment/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        nickName: this.searchData.nickName, //留言人昵称
        message: this.searchData.message, //留言内容
        type: this.searchData.type, //留言类型
        examineStatus: this.searchData.examineStatus, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.MessageList = res.content;
          this.totalCount = res.totalCount;
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 通过
    pass(row, val) {
      var examineStatus;
      if (val == "yes") {
        examineStatus = 1;
      } else {
        examineStatus = 4;
      }
      this.getAxios("/comment/review", {
        examineStatus: examineStatus,
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
          this.getList();
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //查询列表：
    messageSearch() {
      this.currentPage = 1;
      this.loading=true
      this.postAxios("/comment/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        nickName: this.searchData.nickName, //留言人昵称
        message: this.searchData.message, //留言内容
        type: this.searchData.type, //留言类型
        examineStatus: this.searchData.examineStatus, //审核状态
      }).then((res) => {
        if (res.success == true) {
          this.MessageList = res.content;
          this.totalCount = res.totalCount;
          this.loading=false
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //清空查询条件：
    topicClear() {
      this.searchData.type = ""; //留言类型
      this.searchData.message = ""; //留言内容
      this.searchData.nickName = ""; //留言昵称
      this.searchData.examineStatus = ""; //审核状态
    },
    //转时间
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    //转时间
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      // time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
      console.log(currentPage,'---')
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  created() {
    this.getList(); //获取留言列表
  },
  mounted() {
  },
};
</script>
<style scoped lang="less">
.poor {
  width: 100%;
  height: 100%;
  .poor_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
        display: block;
        width: 170px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .done {
      display: flex;
      flex-direction: column;
      width: 100px;

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;
        margin-top: 10px;
        margin-left: 10px;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
    }
  }
}
</style>